export default {
  title_1: 'Instructions',
  operation_desc_1: 'La coque en alliage d’aluminium protège le portefeuille des dommages',
  operation_desc_2: 'Bouton GAUCHE',
  operation_desc_3: 'Se déplacer vers la gauche à l’écran ou revenir à la page précédente',
  operation_desc_4: 'Bouton BAS',
  operation_desc_5: 'Se déplacer vers le bas à l’écran',
  operation_desc_6: 'Écran de 2 pouces pour afficher les transactions liées',
  operation_desc_7: 'Bouton HAUT',
  operation_desc_8: 'Se déplacer vers le haut à l’écran',
  operation_desc_9: 'Bouton DROITE',
  operation_desc_10: 'Se déplacer vers la droite à l’écran ou confirmer les actions',
  operation_desc_11: 'Bouton OK',
  operation_desc_12: 'Confirmer les actions ou entrer dans le menu ; appui long pour allumer/éteindre',
  operation_desc_13: 'Type-C',
  operation_desc_14: 'Pour la charge et la mise à niveau du firmware',

  title_2: 'Comment bien démarrer avec KeyPal',
  get_start_desc_1: 'Initialisation',
  get_start_desc_2: 'Maintenez "',
  get_start_desc_3: '" enfoncé pendant trois secondes pour allumer ; l’écran indiquera que KP_XXX n’est pas activé.',
  get_start_desc_4: 'Étapes d’activation (créer un portefeuille) :',
  get_start_desc_5: '1. Touchez',
  get_start_desc_6: 'pour entrer dans le menu principal.',
  get_start_desc_7: '2. Appuyez sur le bouton bas',
  get_start_desc_8: 'et sélectionnez "Create Wallet"',
  get_start_desc_9: '3. Sauvegardez et vérifiez les mnémoniques dans l’ordre, puis définissez le code PIN ; l’appareil sera activé.',
  get_start_desc_10: 'Utilisez un stylo et du papier ou la boîte mnémonique KEYPAL pour l’enregistrement.',
  get_start_desc_11: 'Veuillez consigner les mnémoniques dans l’ordre et les vérifier',

  title_3: 'Comment connecter KeyPal à TokenPocket',
  connect_desc_1: '1. Assurez-vous que le Bluetooth de KeyPal est activé : [Paramètres] - [Bluetooth].',
  connect_desc_2: '2. Dans TokenPocket, touchez le portefeuille "',
  connect_desc_3: '" en haut à droite, puis sélectionnez le portefeuille matériel KeyPal sur la page "Sélectionner le réseau".',
  connect_desc_4: '3. Sélectionnez Ajouter un appareil. TokenPocket recherchera les appareils ; choisissez celui qui correspond au nom Bluetooth actuel.',
  connect_desc_4_2: '(Rappel : le nom Bluetooth est visible dans [À propos] - [Informations sur l’appareil]. Si le client ne trouve pas l’appareil correspondant, redémarrez le matériel et répétez les étapes.',
  connect_desc_5: 'Après connexion, l’icône Bluetooth de KeyPal apparaît en haut à droite de la page des actifs de TokenPocket.',
  connect_desc_6: 'Connexion réussie',

  title_4: 'Créer des portefeuilles en lot',
  batch_desc_1: '1. Connectez KeyPal à l’application TokenPocket via Bluetooth.',
  batch_desc_2: '2. Touchez l’icône du portefeuille matériel avec l’indicateur Bluetooth en haut à droite de l’application.',
  batch_desc_3: '3. Accédez à "Gestion KeyPal", puis touchez "Ajouter un portefeuille".',
  batch_desc_4: '4. Sur la page, touchez "Ajout en lot" en haut à droite. Terminé.',
  batch_desc_5: 'Pour la connexion KeyPal ↔ TokenPocket, voir ci-dessus',
  batch_desc_6: 'Touchez pour voir les portefeuilles en lot',

  title_5: 'Échange, transfert, etc. — Signature avec code PIN',
  exchange_desc_1: 'Connectez le portefeuille matériel KeyPal à l’application TokenPocket pour effectuer les opérations suivantes :',
  exchange_desc_2: 'Sur les images, les caractères "*" (sur la photo la plus à droite de la première ligne) correspondent aux chiffres (sur la deuxième photo de la deuxième ligne). Suivez les chiffres affichés sur KeyPal pour saisir le code PIN défini lors de la création du portefeuille.',
  exchange_desc_3: 'Saisissez côté client selon les positions affichées sur KeyPal',

  tutorial_title_1: 'Comment vérifier votre appareil KeyPal ?',
  tutorial_desc_1: 'Ouvrez la gestion de l’appareil et consultez la sécurité de l’appareil.',
  tutorial_title_2: 'Comment vérifier que votre adresse appartient à KeyPal ?',
  tutorial_desc_2: 'Connectez KeyPal à TokenPocket, puis sélectionnez pas à pas "Receive" et "Test".',
  tutorial_title_3: 'Comment recevoir des jetons avec KeyPal ?',
  tutorial_desc_3: 'Connectez KeyPal à TokenPocket et sélectionnez "Receive".',
  tutorial_title_4: 'Comment envoyer des jetons avec KeyPal ?',
  tutorial_desc_4: 'Connectez KeyPal à TokenPocket, sélectionnez "Send" et "Transfer".',
  tutorial_title_5: 'Comment saisir le code PIN lors d’une transaction ?',
  tutorial_desc_5: ''
};
